import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '@/utils';
import React, { useCallback, useState } from 'react';
var variantStyles = {
    line: {
        tabs: 'gap-2',
        tab: 'border-b-4 border-transparent p-2',
        tabSelected: 'border-b-4 border-vjwPrimary',
    },
    enclosed: {
        tab: 'py-2 px-4 rounded-t',
        tabSelected: 'border bg-gray-100 border-b-0',
    },
    solid: {
        tab: 'py-2 px-4 bg-white',
        tabSelected: 'text-white bg-vjwPrimary',
    },
};
function Tab(_a) {
    var children = _a.children, index = _a.index, selectedTab = _a.selectedTab, handleSelect = _a.handleSelect, variant = _a.variant, lastIndex = _a.lastIndex;
    var isSelected = selectedTab === index;
    var className = "".concat(cn("".concat(variantStyles[variant].tab, " ").concat(isSelected ? variantStyles[variant].tabSelected : ''), {
        'rounded-s-md': index === 0 && variant === 'solid',
        'rounded-e-md': index === lastIndex && variant === 'solid',
    }));
    return (_jsx("button", { type: 'button', className: className, onClick: function () { return handleSelect(index); }, children: children }));
}
export function TabPanel(_a) {
    var children = _a.children, className = _a.className;
    return _jsx("div", { className: className, children: children });
}
function TabPanels(_a) {
    var children = _a.children, selectedTab = _a.selectedTab, variant = _a.variant;
    return React.Children.map(children, function (child, index) {
        var _a;
        if (!child)
            return null;
        var className = child.props.className
            ? "".concat(child.props.className, " ").concat((_a = variantStyles[variant].tabPanel) !== null && _a !== void 0 ? _a : '')
            : variantStyles[variant].tabPanel;
        if (index === selectedTab && child.type === TabPanel) {
            return _jsx(TabPanel, { className: className, children: child.props.children });
        }
        return null;
    });
}
export function Tabs(_a) {
    var _b;
    var tabs = _a.tabs, _c = _a.variant, variant = _c === void 0 ? 'line' : _c, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, onTabChange = _a.onTabChange, children = _a.children, tabsClassName = _a.tabsClassName;
    var _e = useState(tabIndex), selectedTab = _e[0], setSelectedTab = _e[1];
    var handleSelect = useCallback(function (index) {
        setSelectedTab(index);
        if (onTabChange) {
            onTabChange(index);
        }
    }, [onTabChange]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cn("flex flex-wrap items-center justify-between ".concat(tabsClassName)), children: [_jsx("div", { className: "flex flex-wrap ".concat((_b = variantStyles[variant].tabs) !== null && _b !== void 0 ? _b : ''), style: variant === 'solid'
                            ? {
                                display: 'grid',
                                gridTemplateColumns: "repeat(".concat(tabs.length, ", 1fr)"),
                            }
                            : {}, children: tabs.map(function (tab, index) { return (_jsxs(React.Fragment, { children: [index !== 0 && variant === 'line' && (_jsx("div", { className: 'my-2 h-auto w-0.5 bg-gray-300' })), _jsx(Tab, { index: index, lastIndex: tabs.length - 1, selectedTab: selectedTab, handleSelect: handleSelect, variant: variant, children: tab.label })] }, "tab-".concat(tab.label))); }) }), _jsx("div", { className: 'flex flex-wrap', children: tabs.map(function (tab, index) {
                            return tab.secondaryAction &&
                                selectedTab === index && (_jsx("div", { className: 'secondary-action', children: tab.secondaryAction }, "tab-secondary-action-".concat(tab.label)));
                        }) })] }), _jsx(TabPanels, { selectedTab: selectedTab, variant: variant, children: children })] }));
}
